import React, { useEffect, useState } from "react";
import {
  Button,
  createTheme,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import { DropzoneArea } from "mui-file-dropzone";

import RemoveRedEyeRoundedIcon from "@mui/icons-material/RemoveRedEyeRounded";
import GroupRoundedIcon from "@mui/icons-material/GroupRounded";
import DocumentIcon from "@mui/icons-material/MailLock";
import RateReviewRoundedIcon from "@mui/icons-material/RateReviewRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import SponsorListTable from "./SponsorTable";
import { themeOptions, theming } from "../../theme";
import { ThemeProvider } from "@emotion/react";
import MainModal from "../MainModal";
import ComponentHeader from "../ComponentHeader";
import excelImg from "../../assets/images/ExcelDownload.svg";
import { useDispatch, useSelector } from "react-redux";
// import {
//   createSponsor,
//   deleteSponsor,
//   editSponsor,
//   getAllSponsor,
// } from "../../stores/actions/sponsor.action";
import {
  createSponsor,
  getSponsors,
  deleteSponsor,
  editSponsor,
} from "../../redux/actions/sponsors-action";
import DownloadFile from "../ExcelExport/DownloadFile";
import CircularProgress from "@mui/material/CircularProgress";

const useStyles = makeStyles((theme) => ({
  outlineInputBorder: {
    "& * > fieldset > legend": {
      display: "none",
    },
    // height: "40px",
    "& * > input": {
      borderRadius: "1px",
      padding: "10px !important",
    },
    "& * > select": {
      padding: "3.5px !important",
    },
    // margin: "5px !important"
  },
  addIconButton: {
    // background: "#2C633C !important",
    // color: "white  !important",
    background: "#2C633C !important",
    height: "30px",
    width: "30px",
  },
  searchBtn: {
    backgroundColor: "#2C633C !important",
    paddingRight: "20px !important",
    paddingLeft: "20px !important",
    height: "40px",
  },
  bottomIconButton: {
    color: "white",
  },
  iconBtn: {
    backgroundColor: "#2C633C !important",
    padding: 0,
    borderRadius: "10px !important",
  },
  addIcon: {
    color: "white",
  },
  stack: {
    // border: "1px solid black",
  },
  inputLabel: {
    fontWeight: "bold !important",
    top: "5px",
  },
  button: {
    // backgroundColor: "#2C633C",
    // color: "white !important",
    border: "1px solid transparent",
    "&:hover": {
      //   backgroundColor :"white",
      //   color: "#2C633C !important",
      border: "1px solid #2C633C !important",
    },
  },
  modalDescription: {
    borderTop: "1px solid #cdcdcd !important",
    padding: "15px",
    marginTop: "20px",
    borderBottom: "1px solid #cdcdcd !important",
  },
}));

const initialState = {
  name: "",
  company: "",
  title: "",
  status: "active",
};
export default function SponsorList(props) {
  const classes = useStyles();
  const theme = createTheme(themeOptions);
  const [open, setOpen] = useState(false);
  const [deleteVisible, setdeleteVisible] = useState(false);
  const [editVisible, seteditVisible] = useState(false);
  const [edit, setedit] = useState(false);
  const [selectedrows, setselectedrows] = useState([]);
  const [clearRow, setclearRow] = useState(false);
  const [numberOfRows, setNumberOfRows] = useState(10);

  const [state, setState] = useState(initialState);
  const [submit, setSubmit] = useState(false);

  const dispatch = useDispatch();
  const sponsorsData = useSelector(
    (state) => state?.getSponsorReducer?.data?.data
  );
  let sponsors = sponsorsData;
  // console.log("sponsorsData =============> ", sponsorsData);
  const loading = useSelector((state) => state?.sponsorReducer?.isLoading);

  const [searchText, setSearchText] = useState("");

  if (searchText) {
    sponsors = sponsorsData?.filter((val) => {
      if (
        val?.name?.toLowerCase().includes(searchText.toLowerCase()) ||
        val?.company?.toLowerCase().includes(searchText.toLowerCase()) ||
        val?.title?.toLowerCase().includes(searchText.toLowerCase())
      ) {
        return val;
      }
    });
  }

  const openModal = () => {
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
    setState(initialState);
  };

  const onEditPress = () => {
    if (selectedrows?.length == 1) {
      setedit(!edit);
    } else {
      alert("Please Select one item!");
    }
  };

  const onSelectRow = (e) => {
    if (selectedrows?.length != e?.selectedRows?.length) setedit(false);
    setselectedrows(e?.selectedRows);
    setclearRow(false);
  };

  const onChangeValue = (e, name) => {
    setState((prevState) => ({ ...prevState, [name]: e }));
  };

  const clearState = () => {
    setState({ ...initialState });
  };

  const validate = async () => {
    const isEmpty = Object.keys(state).some(function (x) {
      return state[x] === "" || state[x] === null;
    });

    if (isEmpty) {
      setSubmit(true);
      alert("All fields are required");
      return false;
    } else {
      setSubmit(false);
      return true;
    }
  };

  const onSubmit = () => {
    // const isValid = await validate()
    // if(!isValid) return
    // const result = await dispatch(createSponsor(state));
    // console.log({ result }, { state });
    // if (result?.status) {
    //   setOpen(false);
    //   clearState();
    //   // dispatch(getSponsors());
    //   alert(result?.message);
    // } else {
    //   alert(result?.message);
    // }
    dispatch(createSponsor(state));
    setOpen(false);
    dispatch(getSponsors());
    dispatch(getSponsors());
    dispatch(getSponsors());
  };

  const onDeletePress = () => {
    if (selectedrows?.length == 1) {
      setdeleteVisible(true);
    } else {
      alert("Please Select one item!");
    }
  };

  const onDelete = async () => {
    // const result = await dispatch(deleteSponsor(selectedrows[0]?._id));
    // if (result?.status) {
    //   setdeleteVisible(false);
    //   // dispatch(getSponsors());
    //   setselectedrows([]);
    //   setclearRow(true);
    //   alert(result?.message);
    // } else {
    //   alert(result?.message);
    // }
    dispatch(deleteSponsor(selectedrows[0]?._id));
    setdeleteVisible(false);
    dispatch(getSponsors());
    dispatch(getSponsors());
    dispatch(getSponsors());
  };

  const onEdit = async () => {
    dispatch(editSponsor(selectedrows[0]?._id, selectedrows[0]));
    seteditVisible(false);
    setedit(false);
    dispatch(getSponsors());
    dispatch(getSponsors());
    dispatch(getSponsors());
    // const result = await dispatch(
    //   editSponsor(selectedrows[0], selectedrows[0]?._id)
    // );
    // if (result?.status) {
    //   seteditVisible(false);
    //   setedit(false);
    //   setselectedrows();
    //   setclearRow(true);
    //   dispatch(getSponsors());
    //   alert(result?.message);
    // } else {
    //   alert(result?.message);
    // }
  };

  const onRowChange = (e) => {
    setNumberOfRows(e);
  };

  const ForDownload = sponsors?.map((e) => {
    return {
      Chapter: e?.chapter,
      Name: e?.name,
      Company: e?.company,
      Title: e?.title,
      Website: e?.website,
      Status: e?.status,
    };
  });

  useEffect(() => {
    dispatch(getSponsors());
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Grid container>
        <Grid item xs={12} p={3}>
          <Grid item container>
            <Grid item xs={12}>
              <ComponentHeader
                headerTitle="Sponsors List"
                cbOpenModal={() => {
                  openModal();
                }}
                onSearch={(e) => setSearchText(e)}
              />
            </Grid>
          </Grid>
          <Grid item container sx={{ background: "yellow" }}>
            <Grid
              item
              xs={12}
              sx={{ display: "flex", justifyContent: "flex-end" }}
              mt={2}
            >
              <Stack direction="row" spacing={1}>
                {/* <img src={excelImg} alt={"image"} /> */}
                <div style={{ marginTop: 10 }}>
                  {/* <DownloadFile data={ForDownload ?? ""} FileName={"Sponsor_List"} /> */}
                  {/* <Typography alignSelf={"center"} color="primary">
                                        Download Excel File
                                    </Typography> */}
                </div>
                {edit && (
                  <Button
                    onClick={() => seteditVisible(true)}
                    variant="contained"
                    size="small"
                  >
                    Save
                  </Button>
                )}
                <IconButton
                  style={{ borderRadius: 5 }}
                  onClick={onEditPress}
                  color="primary"
                  size="medium"
                >
                  <RateReviewRoundedIcon fontSize="medium" />
                </IconButton>
                <IconButton
                  style={{ borderRadius: 5 }}
                  // onClick={onDeletePress}
                  color="primary"
                  size="medium"
                >
                  <DeleteRoundedIcon
                    fontSize="medium"
                    onClick={onDeletePress}
                  />
                </IconButton>
              </Stack>
            </Grid>
          </Grid>
          <Grid item container>
            <Grid item xs={12} m={2}>
              <SponsorListTable
                clearRow={clearRow}
                data={sponsors || []}
                progressPending={loading}
                progressComponent={<CircularProgress color="success" />}
                onSelectedRowsChange={onSelectRow}
                edit={edit}
                onChangeRowsPerPage={onRowChange}
                selectedRow={selectedrows}
              />
            </Grid>
          </Grid>

          {/* Confirmation add sponsor */}

          <MainModal
            show={open}
            closeModal={closeModal}
            modalHeadTitle="Create Sponsor"
            // modalUserInfo={selectedItem}
            btnLeftTitle="Back"
            btnRightTitle="Save"
            cb={closeModal}
            btnCloseModal={onSubmit}
            variant="outlined"
            rightVariant="contained"
            sx={{ display: "none" }}
            width="900px"
          >
            <Grid item container>
              <Grid item xs={12} mb={2}>
                <Stack spacing={1}>
                  <InputLabel shrink className={classes.inputLabel}>
                    Name
                  </InputLabel>
                  <TextField
                    onChange={(e) => onChangeValue(e.target?.value, "name")}
                    required
                    placeholder="Name"
                    className={classes.outlineInputBorder}
                    fullWidth
                    variant="outlined"
                    error={!state?.name && submit}
                    helperText={
                      !state?.name && submit ? "Name is required" : ""
                    }
                  />

                  <InputLabel shrink className={classes.inputLabel}>
                    Company
                  </InputLabel>
                  <TextField
                    onChange={(e) => onChangeValue(e.target?.value, "company")}
                    placeholder="Company"
                    required
                    className={classes.outlineInputBorder}
                    fullWidth
                    variant="outlined"
                    error={!state?.company && submit}
                    helperText={
                      !state?.company && submit ? "Company is required" : ""
                    }
                  />

                  <InputLabel shrink className={classes.inputLabel}>
                    Title
                  </InputLabel>
                  <TextField
                    required
                    onChange={(e) => onChangeValue(e.target?.value, "title")}
                    placeholder="Title"
                    className={classes.outlineInputBorder}
                    fullWidth
                    variant="outlined"
                    error={!state?.title && submit}
                    helperText={
                      !state?.title && submit ? "Title is required" : ""
                    }
                  />

                  <InputLabel shrink className={classes.inputLabel}>
                    Website
                  </InputLabel>
                  <TextField
                    onChange={(e) => onChangeValue(e.target?.value, "webiste")}
                    required
                    placeholder="www.example.com"
                    className={classes.outlineInputBorder}
                    fullWidth
                    variant="outlined"
                  />

                  <InputLabel shrink className={classes.inputLabel}>
                    Status
                  </InputLabel>
                  <Select
                    variant="outlined"
                    value={state?.status}
                    // onChange={_handleExerciseTypeOnChange}
                    className={classes.outlineInputBorder}
                    name="status"
                    fullWidth
                    label="."
                    placeholder="Inactive"
                  >
                    {["active", "inactive"].map((item) => (
                      <MenuItem
                        key={item}
                        value={item}
                        onClick={(e) =>
                          onChangeValue(item?.toLowerCase(), "status")
                        }
                      >
                        <Grid container item>
                          <Grid
                            fontStyle={{ textTransform: "capitalize" }}
                            item
                            xs={10}
                          >
                            {item}
                          </Grid>
                        </Grid>
                      </MenuItem>
                    ))}
                  </Select>

                  <div>
                    <DropzoneArea
                      dropzoneText="Tap to upload"
                      showPreviews={false}
                    />
                  </div>
                </Stack>
              </Grid>
            </Grid>
          </MainModal>

          {/* Confirmation delete modal */}

          <MainModal
            show={deleteVisible}
            closeModal={() => setdeleteVisible(false)}
            modalHeadTitle="Delete"
            btnLeftTitle="Ok"
            btnRightTitle="Cancel"
            btnCloseModal={() => setdeleteVisible(false)}
            cb={onDelete}
            variant="contained"
            sx={{ display: "none" }}
            width="500px"
          >
            <Grid item container>
              <Grid item xs={12} mb={2}>
                <Stack spacing={1}>
                  <div className={classes.modalDescription}>
                    <p> Are you sure, you want to Delete?</p>
                  </div>
                </Stack>
              </Grid>
            </Grid>
          </MainModal>

          {/* confirmation edit modal */}

          <MainModal
            show={editVisible}
            closeModal={() => seteditVisible(false)}
            modalHeadTitle="Save"
            btnLeftTitle="Save"
            btnRightTitle="Cancel"
            btnCloseModal={() => seteditVisible(false)}
            variant="contained"
            sx={{ display: "none" }}
            width="500px"
            cb={onEdit}
          >
            <Grid item container>
              <Grid item xs={12} mb={2}>
                <Stack spacing={1}>
                  <div className={classes.modalDescription}>
                    <p> Are you sure, you want to Save?</p>
                  </div>
                </Stack>
              </Grid>
            </Grid>
          </MainModal>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}
